import React from "react";
import CurrencyFlag from "react-currency-flags";
import flags from "react-currency-flags/dist/flags";
import styles from "./CurrencyFlagRound.module.css";
import "styles/imageStyles.css";

interface CurrencyFlagRoundProps {
  currency: string;
  className?: string;
  squareBg?: boolean;
  backgroundColor?: string;
  size?: "sm" | "md" | "lg" | "xl" | "2xl";
}

const SUPPORTED_CURRENCIES = new Set(Object.keys(flags).filter((key) => key !== "$$$"));

export const CurrencyFlagRound: React.FC<CurrencyFlagRoundProps> = React.memo(({
  currency,
  className,
  squareBg = false,
  backgroundColor,
  size,
}) => {
  if (!currency || !SUPPORTED_CURRENCIES.has(currency.toLowerCase())) {
    return null;
  }
  const iconSize = size || (squareBg && "xl") || "lg";
  const sizeClass = `icon-${iconSize}`;

  const flagElement = <CurrencyFlag currency={currency} className={`${styles.flagImage} ${sizeClass}`} />;

  if (squareBg) {
    return <div className={`square icon-3xl ${backgroundColor || "bg-basic-200"}`}>{flagElement}</div>;
  }

  return <div className={`${className || ""} ${styles.flagImageWrapper} ${sizeClass}`}>{flagElement}</div>;
});
